export default __webpack_public_path__ + "static/Doug.Vetsch_social-dc021e120372b3f02b3d62ac0d786409.jpg";